export default "__VITE_ASSET__2sfRC$6S__"